<template>
  <div>
    <transition-group
      enter-active-class="fadeIn"
      leave-active-class="fadeOutFast"
      mode="out-in"
    >
      <template v-for="(question, index) in questions">
        <div
          v-if="checkVisible(question)"
          :id="'question-' + question.id"
          :key="question.id"
          class="mb-5 question-box d-flex align-center justify-center"
        >
          <radio-question
            v-if="question.type === 'radio'"
            :question="question"
            :current-answer="getAnswer(question.id)"
            @selectAnswer="addAnswer($event, index)"
          />
          <text-question
            v-if="question.type === 'text'"
            :question="question"
            :current-answer="getAnswer(question.id)"
            show-upper-space
            is-upper-case
            @updateAnswer="addAnswer($event, index)"
          />
        </div>
      </template>
      <div id="vehicle-form" :key="'form-start'"></div>
      <simple-vehicle-form
        v-if="documentType === 'old'"
        :key="'oldDoc'"
        :show-date-field="isGreenCard"
        class="question-box mb-5"
        @updateData="updateVehicleData"
      />
      <simple-vehicle-form
        v-if="documentType === 'new'"
        :key="'newDoc'"
        :show-date-field="isGreenCard"
        class="question-box mb-5"
        @updateData="updateVehicleData"
      />
      <complete-vehicle-form
        v-if="documentType === 'temp'"
        :key="'tempDoc'"
        :vehicle-type="vehicleType"
        class="question-box mb-5"
        @updateData="updateVehicleData"
      />
      <div v-if="completedSection" :key="'goNextRow'" class="d-flex justify-center">
        <v-btn
          color="#df0100"
          class="base-button"
          depressed
          tile
          dark
          large
          @click="$emit('nextStep', dataLayerEvent)"
        >
          Inainte
        </v-btn>
      </div>
    </transition-group>
  </div>
</template>

<script>
import RadioQuestion from '@/components/RadioQuestion';
import { CONSTANTS, getQuestions } from '@/_utils/static-data';
import TextQuestion from '@/components/TextQuestion';
import SimpleVehicleForm from '@/components/rca/SimpleVehicleForm';
import CompleteVehicleForm from '@/components/rca/CompleteVehicleForm';
export default {
  name: 'VehicleStep',
  components: {
    CompleteVehicleForm,
    SimpleVehicleForm,
    TextQuestion,
    RadioQuestion
  },
  props: {
    vehicleType: {
      type: Object,
      default: null
    },
    sectionType: {
      type: String,
      default: 'rca'
    }
  },
  data() {
    return {
      answers: [],
      lastAnswerIndex: 1,
      vehicleFormAnswers: [],
      validFormData: false
    };
  },
  computed: {
    isGreenCard() {
      return this.sectionType === 'greenCard';
    },
    dataLayerEvent() {
      return this.isGreenCard ? CONSTANTS.greenCardEventVehicle : CONSTANTS.rcaEventVehicle;
    },
    questions() {
      const allQuestions = getQuestions(this.sectionType, 'vehicle');
      let visibleQuestions = [];
      for (const question of allQuestions) {
        if (!question.parent) {
          visibleQuestions.push(question);
        } else if (question.parent && question.visibleIf) {
          const parentAnswer = this.answers.find(el => el.questionId === question.visibleIf.questionId);
          if (parentAnswer?.id === question.visibleIf.answer) {
            visibleQuestions.push(question);
          }
        } else if (question.parent && !question.visibleIf) {
          const parentAnswer = this.answers.find(el => el.questionId === question.parent);
          if (parentAnswer) {
            visibleQuestions.push(question);
          }
        }
      }
      return visibleQuestions;
    },
    documentType() {
      const typeAnswer = this.getAnswer(2);
      return typeAnswer?.value || null;
    },
    totalQuestions() {
      return this.questions.length;
    },
    completedSection() {
      const rootAnswer = this.getAnswer(1);
      if (rootAnswer?.id === 1) {
        return this.totalQuestions === this.answers.length;
      } else if (rootAnswer?.id === 2) {
        return this.totalQuestions === this.answers.length && this.validFormData;
      }
      return false;
    }
  },
  watch: {
    documentType() {
      this.vehicleFormAnswers = [];
      this.validFormData = false;
      this.updateEvent();
    }
  },
  methods: {
    scrollToNext(nextId) {
      setTimeout(() => {
        this.$scrollTo(
          `#question-${nextId}`,
          400,
          {
            offset: -180
          });
      }, 400);
    },
    checkVisible(question) {
      return this.lastAnswerIndex >= question.order;
    },
    getAnswer(questionId) {
      if (!questionId) { return null; }
      return this.answers.find(el => el.questionId === questionId);
    },
    removeChildren(children) {
      if (!children) { return; }
      for (const childId of children) {
        this.removeAnswer(childId);
      }
    },
    removeAnswer(questionId) {
      this.answers = this.answers.filter(el => el.questionId !== questionId);
      this.$emit('updateAnswers', {
        answers: JSON.parse(JSON.stringify(this.answers)),
        isValid: this.completedSection
      });
    },
    addAnswer(answer, index) {
      const isAnswered = !!this.answers.find(el => el.questionId === answer.questionId);
      const currentQuestion = this.questions.find(el => el.id === answer.questionId);
      if (isAnswered) {
        this.answers = this.answers.map((el) => {
          if (el.questionId === answer.questionId) {
            el = answer;
          }
          return el;
        });
        this.removeChildren(currentQuestion.children);
      } else {
        this.answers.push(answer);
        const nextQuestion = this.questions[index + 1];
        if (nextQuestion?.order > this.lastAnswerIndex) {
          this.lastAnswerIndex = nextQuestion.order;
        } else if (currentQuestion?.order >= this.lastAnswerIndex) {
          this.lastAnswerIndex = currentQuestion.order + 1;
        }
        if (this.isMobile) {
          this.scrollToNext(this.lastAnswerIndex);
        }
        if (currentQuestion.id === 2) {
          setTimeout(() => {
            this.$scrollTo(
              '#vehicle-form',
              400,
              {
                offset: -180
              });
          }, 400);
        }
      }
      if (currentQuestion.type === 'text' && (!answer.value || !answer.isValid)) {
        this.removeAnswer(answer.questionId);
      }
      setTimeout(() => {
        this.$emit('updateAnswers', {
          answers: JSON.parse(JSON.stringify(this.answers)),
          vehicleData: JSON.parse(JSON.stringify(this.vehicleFormAnswers)),
          isValid: this.completedSection
        });
      }, 200);
    },
    updateVehicleData({ data, isValid }) {
      if (!data) { return; }
      this.vehicleFormAnswers = JSON.parse(JSON.stringify(data));
      this.validFormData = isValid;
      this.updateEvent();
    },
    updateEvent() {
      setTimeout(() => {
        this.$emit('updateAnswers', {
          answers: JSON.parse(JSON.stringify(this.answers)),
          vehicleData: JSON.parse(JSON.stringify(this.vehicleFormAnswers)),
          isValid: this.completedSection
        });
      }, 200);
    }
  }
};
</script>

<style scoped>
.question-box {
  width: 100%;
  background-color: #E7EFFD;
  padding: 8px;
  border-radius: 4px 4px 4px 4px;
}
</style>
